import { Address } from "./LocationTypes";

export type DeliverySchedule = {
  date: string;
  window: string;
};

export type GroceryDeliveryAvailability = {
  availableDates: {
    date: string;
    isActive: boolean;
  }[];
  availableWindow: string[];
};

export type GroceryItemsRequestBody = {
  organizationId: number;
  groceryCategoryIds: number[];
  productName: string | undefined;
  brand: string | undefined;
  upcCode: number | undefined;
  pageNumber: number;
  pageSize: number;
  serviceUserPersonId: number;
  address: Address;
};

export type GroceryItem = {
  groceryCategoryId: number;
  brand: string;
  upcCode: string;
  minQty: number;
  maxQty: number;
  groceryId: number;
  categoryName: string;
  productName: string;
  imageKey: string;
  imageUrl?: string;
  quantity: number;
  weight: number;
  weightType: string;
  size: string;
  cost: number;
  costType: string;
  totalCost: number;
};

export type GroceryCategory = {
  id: number;
  name: string;
  isActive: boolean;
  organizationToCategoryId: number;
};

export type CategorizedGroceryItems = {
  categoryName: string;
  groceryItems: GroceryItem[];
};

export type BatchFetchImagePayload = {
  folderName: "ccp";
  imageKeys: string[];
};

export type ImageContentResponse = {
  contentType: string;
  fileData: string;
  filename: string;
};

export type CachedGroceryCartItem = {
  groceryId: number;
  categoryName: string;
  productName: string;
  imageKey: string;
  quantity: number;
  weight: number;
  weightType: string;
  size: string;
  cost: number;
  costType: string;
  totalCost: number;
  minQty: number;
  maxQty: number;
};

export type CachedGrocery = {
  getGroceryCarts: CachedGroceryCartItem[];
  deliveryAddress: {
    wandaMarketArea: number;
    address: {
      address1: string;
      address2: string;
      city: string;
      state: string;
      zip: string;
      county: string;
    };
  };
  deliveryNote: string;
};

export type AddTempGroceryCartPayload = {
  serviceUserPersonId: number;
  groceryCartAction?: number;
  groceryCart?: CartGroceryItem;
  deliveryNote?: string;
};

export type ShoppingCartDetails = {
  groceryItems: ShoppingCartGroceryItems[];
  costDetails: CartCostDetails;
};

export type ShoppingCartGroceryItems = {
  categoryName: string;
  groceryItems: CartGroceryItem[];
};

export type CartGroceryItem = {
  groceryId: number;
  categoryName: string;
  productName: string;
  imageKey: string;
  imageUrl?: string;
  quantity: number;
  weight: number;
  weightType: string;
  size: string;
  cost: number;
  costType: string;
  totalCost?: number;
  minQty?: number;
  maxQty?: number;
};

export type CartCostDetails = {
  serviceFee: number;
  tip: number;
  tipAmount: number;
  wandaPlanName: string;
  wandaPlusDiscount: number;
  deliveryFee: number;
  freeDeliveryLimitAmount: number;
  minimumOrderPrice: number;
  totalQuantity: number;
  subTotal: number;
  estimatedTotal: number;
};

export type CartCostDetailsPayload = {
  organizationId: number;
  serviceUserPersonId: number;
  caregiverPersonId: number;
  deliveryDate: string;
  promoCode: string;
  groceryCarts: CachedGroceryCartItem[];
};

export function defaultCartCostDetails() {
  return {
    serviceFee: 0,
    tip: 0,
    tipAmount: 0,
    wandaPlanName: "",
    wandaPlusDiscount: 0,
    deliveryFee: 0,
    freeDeliveryLimitAmount: 0,
    minimumOrderPrice: 0,
    totalQuantity: 0,
    subTotal: 0,
    estimatedTotal: 0,
  };
}

export enum CartDeleteAction {
  EmptyCartItems = 1,
  DeleteDeliveryAddress = 2,
  DeleteDeliveryNote = 3,
}
